export * from './DocumentFullTextModel';
export * from './DocumentFullTextDataModel';